// extracted by mini-css-extract-plugin
module.exports = {"PageWrapper":"StaticPage-module__PageWrapper","Content":"StaticPage-module__Content"};